import {useLocation, useNavigate} from 'react-router';

export const useAppRedirect = (alternativePath?: string) => {
  const location = useLocation();
  const navigate = useNavigate();

  const redirect = (path: string) => {
    const currentPath = decodeURIComponent(document.location.pathname);

    if (currentPath !== path) {
      navigate(path, {replace: true, state: location.state});
    } else if (alternativePath) {
      navigate(alternativePath, {replace: true, state: location.state});
    }
  };

  return redirect;
};
